'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation as a shown when the user navigates to a non-existent
 * page during assessment.
 */
export function DeviceError404Animation(props: IAnimationProps) {
  const loadAnimation = () => import('../raw-json/404/device-error-404.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="DeviceError404Animation"
    />
  );
}
